export const habaContactForm = {
  habaContactForm: {
    success: {
      title: 'Thank you for your inquiry',
      txt: 'The response to your inquiry will be sent via email to the following address',
    },
    messages: {
      notValidError: 'Invalid entries',
      serverError: 'An unknown error has occurred',
    },
    form: {
      legend: 'Contact form',
      reason: {
        label: 'Reason for your inquiry',
        error: 'Please select the reason for your inquiry',
      },
      reference: {
        label: 'Subject',
        error: 'Please enter a subject',
      },
      file: {
        label: 'Upload file..',
        error: 'Please select a file',
      },
      message: {
        label: 'Your message',
        error: 'Please enter your message',
      },
      isInstitution: {
        true: {
          label: 'Institution',
        },
        false: {
          label: 'Company',
        },
      },
      name: {
        label: 'Name',
        error: 'Please enter your name',
      },
      customerNumber: {
        label: 'Customer number (optional)',
        error: 'Please enter your customer number',
      },
      orderNumber: {
        label: 'Order number (optional)',
        error: 'Please enter your order number',
      },
      street: {
        label: 'Street',
        error: 'Please enter your street address',
      },
      houseNumber: {
        label: 'House number',
        error: 'Please enter your house number',
      },
      postcode: {
        label: 'Postal code',
        error: 'Please enter your postal code',
      },
      location: {
        label: 'City',
        error: 'Please enter your city',
      },
      country: {
        label: 'Country',
        error: 'Please select your country',
      },
      email: {
        label: 'Email address',
        error: 'Please enter your email address',
      },
      isAgreed: {
        label:
          'I have read and acknowledge the terms and conditions and privacy policy of the Haba Family Group.',
        error: '',
      },
      submit: 'Submit',
    },
  },
};
